// extracted by mini-css-extract-plugin
module.exports = {"icon":"PlayIconButton_icon__xdYBB","placeholder":"PlayIconButton_placeholder__2noXu"};